import React from "react";
//import {dispatch} from "redux";
import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import { ERROR_MSG, MIS_ACTION, DOWNLOAD_EXCEL_CONSTANTS } from "../constant";
import { toast } from "react-toastify";
import { get, orderBy, round } from "lodash";
import { successToastStyle, errorToastStyle } from "../customToast";
import addBusinessDays from "date-fns/addBusinessDays/index.js";
import { off } from "screenfull";
import { debounce } from "lodash";
// import store from "../store";

// const dispatch = createDispatch(store);

export const misFilter = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.MIS_FILTER_START
    });
    return requestMethod(apiServices.misFilterParams(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.MIS_FILTER_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.MIS_FILTER_FAILURE
        });
      });
  };
};

export const projectMinistry = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.PROJECT_MINISTRY_START
    });
    return requestMethod(apiServices.projectMinistryParams(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.PROJECT_MINISTRY_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.PROJECT_MINISTRY_FAILURE
        });
      });
  };
};

export const projectScheme = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.PROJECT_SCHEME_START
    });
    return requestMethod(apiServices.projectSchemeParams(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.PROJECT_SCHEME_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.PROJECT_SCHEME_FAILURE
        });
      });
  };
};

export const projectMultiLocation = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.PROJECT_MULTI_LOCATION_START
    });
    return requestMethod(apiServices.projectMultiLocationParams(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.PROJECT_MULTI_LOCATION_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.PROJECT_MULTI_LOCATION_FAILURE
        });
      });
  };
};

export const projectSingleLocation = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.PROJECT_SINGLE_LOCATION_START
    });
    return requestMethod(apiServices.projectSingleLocationParams(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.PROJECT_SINGLE_LOCATION_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.PROJECT_SINGLE_LOCATION_FAILURE
        });
      });
  };
};

export const issueState = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.ISSUE_STATE_START
    });
    return requestMethod(apiServices.issueState(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.ISSUE_STATE_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.ISSUE_STATE_FAILURE
        });
      });
  };
};

export const issueStatus = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.ISSUE_STATUS_START
    });
    return requestMethod(apiServices.issueStatus(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.ISSUE_STATUS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.ISSUE_STATUS_FAILURE
        });
      });
  };
};

export const projectStatus = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.PROJECT_STATUS_START
    });
    return requestMethod(apiServices.projectStatus(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.PROJECT_STATUS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.PROJECT_STATUS_FAILURE
        });
      });
  };
};

export const schemeProject = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.SCHEME_PROJECT_START
    });
    return requestMethod(apiServices.schemeProject(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.SCHEME_PROJECT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.SCHEME_PROJECT_FAILURE
        });
      });
  };
};

export const getAllMoms = (requestMethod = request, params) => {
  return function(dispatch) {
    const requestPayload = {
      offset: 0,
      limit: 10,
      groupCategory: "CENTRAL",
      search: "",
      projectGroupBy: true,
      taskCompletionDate: [],
      delayedProject: [],
      costOverRun: [],
      projectCost: []
    };

    return requestMethod(apiServices.getissueListParams(requestPayload))
      .then(momResponse => {
        const payload = momResponse.data;
        dispatch({
          type: MIS_ACTION.GET_MOMS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        // dispatch({
        //   type: MIS_ACTION.GET_MOMS_FAILURE
        // });
      });
  };
};

export const fetchProjectReport = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_PROJECT_REPORT_START
    });
    return requestMethod(apiServices.fetchProjectReport(params))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.FETCH_PROJECT_REPORT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_PROJECT_REPORT_FAILURE
        });
      });
  };
};

export const fetchStateProjectReport = (params, requestMethod = request) => {
  return function(dispatch) {
    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 10,
      groupCategory: "CENTRAL",
      projectFlags: [],
      projectLocation: [],
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };

    dispatch({
      type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_START
    });

    return requestMethod(apiServices.fetchStateProjectReport(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_SUCCESS,
          payload
        });
      })
      .catch(error => {
        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_FAILURE
        });
      });
  };
};

export const clearStateProjectReport = (
  stateValue,
  monitoringValue,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statepayload;

    if (Object.keys(stateValue).length === 0) {
      statepayload = [];
    } else {
      statepayload = stateValue.value === "" ? [] : [stateValue.value];
    }

    let monitoringPayload;
    if (Object.keys(monitoringValue).length === 0) {
      monitoringPayload = [];
    } else {
      monitoringPayload =
        monitoringValue.value === "" ? [] : [monitoringValue.value];
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: offset,
      limit: 10,
      groupCategory: "CENTRAL",
      projectFlags: monitoringPayload,
      projectLocation: statepayload,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };

    dispatch({
      type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_START
    });

    return requestMethod(apiServices.fetchStateProjectReport(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_SUCCESS,
          payload
        });
      })
      .catch(error => {
        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_FAILURE
        });
      });
  };
};

export const fetchStateProjectReport2 = (
  stateValue,
  monitoringValue,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    //let statepayload = stateValue.length !== 0 ? stateValue : [];
    let statepayload;

    if (Object.keys(stateValue).length === 0) {
      statepayload = [];
    } else {
      statepayload = stateValue.value === "" ? [] : [stateValue.value];
    }

    let monitoringPayload;
    if (monitoringValue.value === " ") {
      monitoringPayload = [];
    } else {
      monitoringPayload =
        monitoringValue.value === "" ? [] : [monitoringValue.value];
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: offset,
      limit: 10,
      groupCategory: "CENTRAL",
      projectFlags: monitoringPayload,
      projectLocation: statepayload,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };

    dispatch({
      type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_START
    });

    return requestMethod(apiServices.fetchStateProjectReport(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_SUCCESS,
          payload
        });
      })
      .catch(error => {
        dispatch({
          type: MIS_ACTION.FETCH_STATE_PROJECT_REPORT_FAILURE
        });
      });
  };
};

export const getMisissueSummaryFileDownload = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      meetingType: "DPIIT",
      recipientState: [123],
      fileId: "1fcdc849-7c3b-4f21-add4-62acb71beb7e#2372_122",
      pageNo: 1,
      isLastPage: false
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_START
    });
    return requestMethod(
      apiServices.getMisissueSummaryFileDownload(requestPayload)
    )
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_FAILURE
        });
      });
  };
};

export const onClearDownloadAction = () => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.ISSUE_SUMMARY_URL_SUCCESS
    });
  };
};

export const getMisissueSummaryFileCreate = (
  statepayload,
  selmeetingType,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      meetingType: meetingTypes,
      recipientState: statemodifiedPay
    };
    dispatch({
      type: MIS_ACTION.ISSUE_SUMMARY_CREATE_FILE_START
    });
    return requestMethod(
      apiServices.getMisissueSummaryFileCreate(requestPayload)
    )
      .then(async misResponse => {
        const payload = {
          key: misResponse.data.data
        };
        if (misResponse.data !== undefined && misResponse.data !== null) {
          debouncePromiseMis(500, payload, data => {
            dispatch({
              type: MIS_ACTION.ISSUE_SUMMARY_URL_START
            });
            if (data && data.data.url) {
              dispatch({
                type: MIS_ACTION.ISSUE_SUMMARY_URL_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: MIS_ACTION.ISSUE_SUMMARY_URL_FAILURE
              });
            }
          });
          //}
        }
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.ISSUE_SUMMARY_CREATE_FILE_FAILURE
        });
      });
  };
};

const debouncePromiseMis = function(time, key, callback) {
  const callApi = debounce(async () => {
    const downLoadResp = await request(
      apiServices.getMisissueSummaryFileDownload(key)
    );
    const { data, status } = downLoadResp.data;
    if (!status) {
      return debouncePromiseMis(time + 500, key, callback);
    } else {
      typeof callback === "function" && callback(downLoadResp.data, status);
    }
  }, time);
  callApi();
};

export const fetchMonitoringValue = selVlue => {
  return function(dispatch) {
    const payload = selVlue;

    dispatch({
      type: MIS_ACTION.SELECTED_MONITORING_VALUE,
      payload
    });
  };
};

export const fetchMeetingValue = selVlue => {
  return function(dispatch) {
    const payload = selVlue;
    dispatch({
      type: MIS_ACTION.SELECTED_MEETING_VALUE,
      payload
    });
  };
};

export const fetchSelectedStateValue = selVlue => {
  return function(dispatch) {
    const payload = selVlue;

    dispatch({
      type: MIS_ACTION.SELECTED_STATE_VALUE,
      payload
    });
  };
};

export const clearSelectedStateValue = selId => {
  return function(dispatch) {
    const payload = selId;

    dispatch({
      type: MIS_ACTION.CLEAR_STATE_VALUE,
      payload
    });
  };
};

export const getIssueList = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.STATES_ISSUE_LIST_DATA_START
    });
    return requestMethod(apiServices.getGroupById(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.STATES_ISSUE_LIST_DATA_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_ISSUE_LIST_DATA_FAILURE
        });
      });
  };
};

export const fetchSelectedMonitoringValue2 = selectedMonitering => {
  return function(dispatch) {
    const payload = selectedMonitering;

    dispatch({
      type: MIS_ACTION.SELECTED_MONITORING_VALUE,
      payload
    });
  };
};

export const fetchSelectedMonitoringValue = selVal => {
  const payload = selVal;
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.SELECTED_MONITORING_VALUE,
      payload
    });
  };
};

export const clearSelectedMonitringValue = selVal => {
  const payload = selVal;
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.CLEAR_MONITORING_VALUE,
      payload
    });
  };
};

// export const getMisReportListAction = (statepayload, selmeetingType, offset, requestMethod = request) => {

//   return function (dispatch) {

//     let statemodifiedPay
//     if (statepayload === undefined || statepayload === null) {

//     } else {
//       if (Object.keys(statepayload).length === 0) {
//         statemodifiedPay = [];
//       } else {
//         statemodifiedPay = statepayload.value === "" ? [] : [parseInt(statepayload.value)];
//       }
//     }

//     let meetingTypes;
//     if (selmeetingType === undefined || selmeetingType === null) {

//     } else {

//       if (selmeetingType.value === ' ') {
//         meetingTypes = ""

//       } else {
//         meetingTypes = selmeetingType.value;
//       }
//     }

//     const requestPayload = {
//       sortBy: "CREATED_DATE",
//       sortOrder: "DESC",
//       offset: 0,
//       limit: 1000,
//       groupCategory: "CENTRAL",
//       meetingType: meetingTypes,
//       agendaStages: ["CONCLUDED"],

//       recipientState: statemodifiedPay,
//       projectCost: [],
//       delayedProject: [],
//       costOverRun: []
//     }
//     dispatch({
//       type: MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_START
//     });
//     return requestMethod(apiServices.getMisReportList(requestPayload))
//       .then(misResponse => {
//         const payload = misResponse.data;

//         dispatch({
//           type: MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_SUCCESS,
//           payload
//         });
//       })
//       .catch(() => {
//         dispatch({
//           type: MIS_ACTION.STATES_MIS_REPORT_LIST_DATA_FAILURE
//         });
//       });
//   };
// };

export const getIssuesReviewed = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 1000,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_START
    });
    return requestMethod(apiServices.getIssuesReviewed(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_REVIEWED_FAILURE
        });
      });
  };
};

export const getIssuesResolved = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 1000,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_START
    });
    return requestMethod(apiServices.getIssuesResolved(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_RESOLVED_FAILURE
        });
      });
  };
};

export const getIssuesPending = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 1000,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_ISSUES_PENDING_START
    });
    return requestMethod(apiServices.getIssuesPending(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_PENDING_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_ISSUES_PENDING_FAILURE
        });
      });
  };
};

export const getIssuesTimelineLapsed = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 1000,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_START
    });
    return requestMethod(apiServices.getIssuesTimelineLapsed(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_TIMELINE_LASPSED_FAILURE
        });
      });
  };
};

export const getmeetingsCount = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: 0,
      limit: 1000,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_MEETING_COUNT_START
    });
    return requestMethod(apiServices.getmeetingsCount(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES__MIS_MEETING_COUNT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES__MIS_MEETING_COUNT_FAILURE
        });
      });
  };
};

export const getmeetingsDateAction = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  return function(dispatch) {
    let statemodifiedPay;
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }

    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }

    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: offset,
      limit: 10,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      agendaStages: ["CONCLUDED"],

      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    dispatch({
      type: MIS_ACTION.STATES_MIS_MEETING_DATE_START
    });
    return requestMethod(apiServices.getmeetingsDate(requestPayload))
      .then(misResponse => {
        const payload = misResponse.data;

        dispatch({
          type: MIS_ACTION.STATES__MIS_MEETING_DATE_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES__MIS_MEETING_DATE_FAILURE
        });
      });
  };
};

export const getMisListAction = (
  statepayload,
  selmeetingType,
  offset,
  requestMethod = request
) => {
  // const meetingTypes = selmeetingType ? selmeetingType.value : "";
  // const statemodifiedPay = statepayload ? [statepayload] : [];
  return function(dispatch) {
    let statemodifiedPay;
    let meetingTypes;
    if (selmeetingType === undefined || selmeetingType === null) {
    } else {
      if (selmeetingType.value === " ") {
        meetingTypes = "";
      } else {
        meetingTypes = selmeetingType.value;
      }
    }
    if (statepayload === undefined || statepayload === null) {
    } else {
      if (Object.keys(statepayload).length === 0) {
        statemodifiedPay = [];
      } else {
        //statemodifiedPay =  [parseInt(statepayload.value)];
        statemodifiedPay =
          statepayload.value === "" ? [] : [parseInt(statepayload.value)];
      }
    }
    const requestPayload = {
      sortBy: "CREATED_DATE",
      sortOrder: "DESC",
      offset: offset,
      limit: 10,
      groupCategory: "CENTRAL",
      meetingType: meetingTypes,
      //projectFlags: [monitoringPayload],
      recipientState: statemodifiedPay,
      projectCost: [],
      delayedProject: [],
      costOverRun: []
    };
    // dispatch({
    //   type: MIS_ACTION.STATES_MIS_LIST_DATA_START
    // });
    return requestMethod(apiServices.getMisList(requestPayload))
      .then(resp => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_LIST_DATA_SUCCESS,
          payload: resp.data
        });
        return resp;
      })
      .catch(err => {
        dispatch({
          type: MIS_ACTION.STATES_MIS_LIST_DATA_FAILURE
        });
      });
  };
};

export const fetchProjectDetail = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_PROJECT_DETAIL_START
    });
    return requestMethod(apiServices.fetchProjectDetail(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_PROJECT_DETAIL_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_PROJECT_DETAIL_FAILURE
        });
      });
  };
};

export const activeReport = params => {
  return function(dispatch) {
    return dispatch({
      type: MIS_ACTION.ACTIVE_REPORT,
      params
    });
  };
};

export const fetchAllSchemes = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_ALL_SCHEMES_START
    });
    return requestMethod(apiServices.fetchAllSchemes(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_ALL_SCHEMES_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_ALL_SCHEMES_FAILURE
        });
      });
  };
};

export const fetchAllProjectStatus = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_ALL_PROJECT_STATUS_START
    });
    return requestMethod(apiServices.fetchAllProjectStatus())
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_ALL_PROJECT_STATUS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_ALL_PROJECT_STATUS_FAILURE
        });
      });
  };
};

export const fetchImplementationModes = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_IMPLEMENTATION_MODES_START
    });
    return requestMethod(apiServices.fetchImplementationModes())
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_IMPLEMENTATION_MODES_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_IMPLEMENTATION_MODES_FAILURE
        });
      });
  };
};

export const fetchFlatFileReport = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_FLAT_FILE_REPORT_START
    });
    return requestMethod(apiServices.fetchFlatFileReport(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_FLAT_FILE_REPORT_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_FLAT_FILE_REPORT_FAILURE
        });
      });
  };
};

export const fetchAllIssueCategories = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_START
    });
    return requestMethod(apiServices.fetchAllIssueCategories())
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_ALL_ISSUE_CATEGORY_FAILURE
        });
      });
  };
};

export const fetchIssueSubCategories = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_START
    });
    return requestMethod(apiServices.fetchIssueSubCategories(params))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_ISSUE_SUB_CATEGORIES_FAILURE
        });
      });
  };
};

export const fetchAllSectors = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.FETCH_ALL_SECTORS_START
    });
    return requestMethod(apiServices.fetchAllSectors())
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.FETCH_ALL_SECTORS_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.FETCH_ALL_SECTORS_FAILURE
        });
      });
  };
};

// Excel Downloads Start

export const downloadProjectSummary = (
  report,
  data,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_START
    });
    return requestMethod(apiServices.downloadProjectSummary(report, data))
      .then(misResponse => {
        const payload = misResponse.data;
        dispatch({
          type: MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_SUCCESS,
          payload
        });
        if (!payload.status) {
          dispatch({
            type: MIS_ACTION.DOWNLOAD_MIS_SUMMARY_STATUS
          });
        }
        return payload;
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.DOWNLOAD_PROJECT_SUMMARY_FAILURE
        });
      });
  };
};

export const uploadProjectSummary = (key, requestMethod = request) => {
  return function(dispatch) {
    return requestMethod(apiServices.uploadProjectSummary(key))
      .then(misResponse => {
        if (misResponse.data.data && misResponse.data.status) {
          dispatch({
            type: MIS_ACTION.DOWNLOAD_MIS_SUMMARY_STATUS
          });
        }
        return misResponse.data;
      })
      .catch(e => {
        dispatch({
          type: MIS_ACTION.DOWNLOAD_MIS_SUMMARY_STATUS
        });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_FAILED}</p>,
          errorToastStyle
        );
      });
  };
};

// Excel Downloads End

export const getAllStatesAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.STATES_DATA_START
    });
    return requestMethod(apiServices.getAllState())
      .then(resp => {
        // const {
        //   data: { data }
        // } = resp;
        dispatch({
          type: MIS_ACTION.STATES_DATA_SUCCESS,
          payload: resp.data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.STATES_DATA_FAILURE
        });
      });
  };
};

export const getRecipientMinistryStateAction = (
  key,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_START
    });
    return requestMethod(apiServices.getRecipientMinistryState(key))
      .then(misResponse => {
        if (misResponse.data.data && misResponse.data.status) {
          dispatch({
            type: MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_SUCCESS,
            payload: misResponse.data.data
          });
        }
        return misResponse.data;
      })
      .catch(e => {
        dispatch({
          type: MIS_ACTION.DOWNLOAD_SPONORING_MINISTRY_FAILURE
        });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_FAILED}</p>,
          errorToastStyle
        );
      });
  };
};

/**
 * Action to get all the Documents to display in MIS section
 * @param requestMethod
 */
export const getAllDocuments = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.DOCUMENTS_DATA_START
    });
    return requestMethod(apiServices.getDocumentsData())
      .then(resp => {
        let documentDTOList =
          orderBy(resp.data.data.documentDTOList, "createdDate", "desc") || [];
        dispatch({
          type: MIS_ACTION.DOCUMENTS_DATA_SUCCESS,
          payload: documentDTOList
        });
        return documentDTOList;
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.DOCUMENTS_DATA_FAILURE
        });
      });
  };
};

export const getDistrictDepartmentByParentIds = (
  params,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: MIS_ACTION.GET_DD_BY_PARENTID_START
    });
    return requestMethod(apiServices._getDistrictDepartmentByParentIds(params))
      .then(response => {
        const payload = response.data;
        dispatch({
          type: MIS_ACTION.GET_DD_BY_PARENTID_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: MIS_ACTION.GET_DD_BY_PARENTID_FAILURE
        });
      });
  };
};
